import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import { Shield, FileText, Archive, ShieldAlert } from "lucide-react";

const TABS = [
  { to: "/legal/disclaimer", label: "Disclaimer", icon: ShieldAlert, id: "disclaimer" },
  { to: "/legal/privacy", label: "Privacy", icon: Shield, id: "privacy" },
  { to: "/legal/terms", label: "Terms", icon: FileText, id: "terms" },
  { to: "/legal/retention", label: "Data Retention", icon: Archive, id: "retention" },
];

// Shared chrome for the three legal documents — one masthead, one nav, one footer.
export const LegalLayout = ({ eyebrow, title, updated, active, children }) => (
  <div className="min-h-screen bg-canvas">
    <div className="max-w-3xl mx-auto px-6 py-16">
      <Link to="/" className="font-mono text-xs uppercase tracking-widest hover:underline">← Checkmate</Link>
      <div className="overline mt-6 mb-2">§ {eyebrow}</div>
      <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-4">{title}</h1>
      <div className="flex flex-wrap gap-0 border-b-2 border-ink mb-8" data-testid="legal-tabs">
        {TABS.map((t) => (
          <Link
            key={t.id}
            to={t.to}
            data-testid={`legal-tab-${t.id}`}
            className={`px-4 py-2.5 font-mono uppercase text-[10px] tracking-widest inline-flex items-center gap-2 border-2 border-b-0 -mb-0.5 transition-colors ${
              active === t.id ? "border-ink bg-ink text-white" : "border-transparent text-muted-foreground hover:text-ink"}`}
          >
            <t.icon className="w-3 h-3" /> {t.label}
          </Link>
        ))}
      </div>
      <div className="font-mono text-sm space-y-6">
        <p className="text-muted-foreground" data-testid="legal-version">
          Version {updated}. This document is a plain-language contract, not legal advice — have counsel review it
          against your state's requirements before you rely on it in a dispute.
        </p>
        {children}
      </div>
    </div>
    <Footer />
  </div>
);

export const Clause = ({ n, heading, children }) => (
  <section data-testid={`clause-${n}`}>
    <h2 className="font-heading font-black text-base md:text-lg mt-8 mb-2">{n}. {heading}</h2>
    <div className="space-y-2 leading-relaxed">{children}</div>
  </section>
);
